import React, { useMemo } from "react";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ApprovalIcon from "@mui/icons-material/Approval";
import PanToolIcon from "@mui/icons-material/PanTool";
import SmsFailedIcon from "@mui/icons-material/SmsFailed";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { DoneAll } from "@mui/icons-material";
import { Box, Card, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

// Each status gets its own semantic color, unlike the flat all-orange look
// this replaced — makes Success/Failed/Rejected distinguishable at a glance
// instead of relying on reading the label text.
const STATUS_TILES = [
  { code: "P", label: "Pending", filterValue: "pending", icon: AutorenewIcon, color: "#F59E0B" },
  { code: "A", label: "Applied", filterValue: "applied", icon: ApprovalIcon, color: "#3B82F6" },
  { code: "W", label: "Waiting", filterValue: "waiting", icon: PanToolIcon, color: "#8B5CF6" },
  { code: "S", label: "Success", filterValue: "success", icon: DoneAll, color: "#10B981" },
  { code: "F", label: "Failed", filterValue: "failed", icon: SmsFailedIcon, color: "#EF4444" },
  { code: "R", label: "Rejected", filterValue: "rejected", icon: ThumbDownIcon, color: "#DC2626" },
];

export default function StatusCards({ campaignInfo }) {
  const navigate = useNavigate();

  const countByCode = useMemo(() => {
    const map = {};
    (campaignInfo || []).forEach((entry) => {
      map[entry._id] = entry.details?.length || 0;
    });
    return map;
  }, [campaignInfo]);

  return (
    // Matches the responsive breakpoints its sibling CampaignCard is given
    // by its caller (full width on mobile, half on desktop) — this is the
    // component's own Grid item, meant to sit directly in a Grid container
    // alongside that sibling, not to be wrapped in another Grid item itself.
    <Grid item xs={12} lg={6}>
      <Grid container spacing={2}>
        {STATUS_TILES.map(({ code, label, filterValue, icon: Icon, color }) => (
          <Grid item xs={4} key={code}>
            <Card
              variant="outlined"
              sx={{
                p: 2,
                borderRadius: 3,
                borderColor: "rgba(15, 23, 42, 0.08)",
                cursor: "pointer",
                transition: "box-shadow 0.15s ease, transform 0.15s ease",
                "&:hover": {
                  boxShadow: "0 6px 16px rgba(15, 23, 42, 0.1)",
                  transform: "translateY(-1px)",
                },
              }}
              onClick={() => navigate("/payments/status", { state: { status: filterValue } })}
            >
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box>
                  <Typography component="div" variant="h5" fontWeight={700}>
                    {countByCode[code] || 0}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {label}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: `${color}1A`,
                    flexShrink: 0,
                  }}
                >
                  <Icon sx={{ color, fontSize: "20px" }} />
                </Box>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}
